import { useState } from 'react';
import { CreateScenarioRequest, Nullable } from '@xplan-pension-switching/common';
import { useCreateScenarioMutation } from '../../services';
import { useNavigate } from 'react-router';
import { useModal } from '@iress-oss/ids-components';
import { isNullOrUndefinedOrEmpty } from '../../helpers';
import { ScenarioValues } from '../../pages/Scenarios/Scenarios';
import { usePageSearchParams } from '../UsePageSearchParams/UsePageSearchParams';

export const useScenariosHandlers = () => {
    const [request, setRequest] = useState<Nullable<CreateScenarioRequest>>(null);
    const mutation = useCreateScenarioMutation();
    const { entityId } = usePageSearchParams();
    const navigate = useNavigate();
    const { showModal } = useModal();

    const mainFormSubmitHandler = ({
        'scenario-name': scenarioName,
        'scenario-owner': scenarioOwner,
        'scenario-case': scenarioCase,
    }: ScenarioValues) => {
        if (isNullOrUndefinedOrEmpty(scenarioName) || isNullOrUndefinedOrEmpty(scenarioOwner)) return;

        const toUpdate: CreateScenarioRequest = {
            ownerId: Number(scenarioOwner),
            caseId: scenarioCase ? Number(scenarioCase) : null,
            scenarioName,
            retirementFundIds: [],
        };

        setRequest(toUpdate);
        showModal(`scenario-modal`, true);
    };

    const modalSubmitHandler = async (
        selectedFunds: number[]
    ): Promise<{ success: boolean; errorMessage: Nullable<string> }> => {
        if (isNullOrUndefinedOrEmpty(selectedFunds) || isNullOrUndefinedOrEmpty(request)) {
            return { success: false, errorMessage: 'Select at least one plan to continue' };
        }
        const newRequest = { ...request, retirementFundIds: selectedFunds } as CreateScenarioRequest;
        return await mutation
            .mutateAsync({ entityId, request: newRequest })
            .then(result => {
                navigate({
                    pathname: 'current-plan-projections',
                    search: `?entityid=${entityId}&ownerId=${request?.ownerId}&scenarioId=${result.scenario?.id}`,
                });
                return { success: result && result.scenario?.id > 0, errorMessage: null };
            })
            .catch(error => {
                return { success: false, errorMessage: error.message };
            });
    };

    return { mainFormSubmitHandler, modalSubmitHandler, selectedEntityId: request?.ownerId };
};
